export const input = {    
    baseStyle:{
        backgroundColor: 'white',
    },
    variants: {
        outline: {
            rounded: "sm",
            field:{
                bg: 'white',
                rounded:"sm",
                _focus: {
                    // bg: 'gray.50',
                    borderColor: 'gray.700',
                    shadow: 'none'
                },
                _hover:{
                    borderColor: 'gray.500',
                }                
            }
        },
        flushed:{
            field:{
                rouned: 'sm',                
                shadow: 'none',
                borderBottomWidth: "1px",
                _focus: {
                    // bg: 'gray.50',
                    borderColor: 'brand.500',
                    shadow: 'none'
                },
                _disabled: {
                    color: 'gray.300'
                }
            }
        },
        search:{
            field:{
                rounded: "md",
                shadow: "none",
                borderWidth: 0,
                bg: "gray.100",
                _focus: {
                    bg: 'gray.200',                    
                    shadow: 'none'
                },

            }
        },
    },
    defaultProps: {
        // focusBorderColor: 'brand.700',
    }
}

